import React, { useEffect, useState } from 'react';
import AppHeader from '../../component/AppHeader/app-header';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { apiFetch } from '../../hooks/usePayment';
import './PaymentSuccess.scss';

const PaymentSuccessPage = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const [orderData, setOrderData] = useState(null);
	const [loading, setLoading] = useState(true);

	const orderId = searchParams.get('orderId');

	useEffect(() => {
		if (!orderId) {
			navigate('/subscription-plan');
			return;
		}

		const fetchOrder = async () => {
			try {
				const res = await apiFetch(`/payment/order/${orderId}`);
				setOrderData(res.data);
			} catch (err) {
				console.error(err);
				navigate('/subscription-plan');
			} finally {
				setLoading(false);
			}
		};

		fetchOrder();
	}, [orderId, navigate]);

	if (loading) {
		return (
			<main className="main-wrapper">
				<AppHeader
					title="Payment Status"
					username="Sanjay Choudhary"
				/>
				<div className="payment-success-container">
					<div className="payment-card">Loading...</div>
				</div>
			</main>
		);
	}

	if (!orderData) return null;

	const {
		id,
		plan,
		amount = 0,
		discount = 0,
		tax = 0,
		total = 0,
		paymentId,
		createdAt,
	} = orderData;

	return (
		<main className="main-wrapper">
			<AppHeader
				title="Payment Status"
				username="Sanjay Choudhary"
			/>

			<div className="payment-success-container">
				<div className="payment-card">
					{/* HEADER */}
					<div className="payment-header">
						<div className="success-icon">✔</div>
						<div>
							<p className="order-id">ORDER #{id}</p>
							<h3>Payment Successful</h3>
							<p className="email-text">We’ve sent a confirmation email to user@example.com</p>
						</div>
					</div>

					{/* BODY */}
					<div className="payment-body">
						{/* LEFT SIDE */}
						<div className="plan-details">
							<div className="plan-card">
								<div className="plan-header">
									<h5>Plan Details</h5>
								</div>

								<div className="plan-content">
									<div>
										<strong>{plan} Plan</strong>
										<p>Annual Plan • Pro Features</p>
										<p className="valid">Valid Till: {new Date(createdAt).toDateString()}</p>
									</div>

									<span className="price">₹{amount}</span>
								</div>
							</div>

							{/* NEXT STEPS */}
							<h6 className="mt-4">What’s Next?</h6>

							<div className="steps">
								<div className="step-box">
									<span>1</span>
									<div>
										<strong>Setup Organization</strong>
										<p>Configure your business & GST info</p>
									</div>
								</div>

								<div className="step-box">
									<span>2</span>
									<div>
										<strong>Setup Inventory</strong>
										<p>Add products and manage your stock</p>
									</div>
								</div>

								<div className="step-box">
									<span>3</span>
									<div>
										<strong>Start Creating Invoices</strong>
										<p>Create your first invoice and send to customers</p>
									</div>
								</div>
							</div>

							<button
								className="btn-primary"
								onClick={() => navigate('/organizationDetail')}
							>
								Complete Organisation Setup
							</button>
						</div>

						{/* RIGHT SIDE */}
						<div className="order-summary-payment">
							<h5>Order Summary</h5>

							<div className="summary-row">
								<span>Sub Total</span>
								<span>₹{amount}</span>
							</div>

							<div className="summary-row discount">
								<span>Discount</span>
								<span>-₹{discount}</span>
							</div>

							<div className="summary-row">
								<span>Taxes</span>
								<span>₹{tax}</span>
							</div>

							<hr className="border-2 border-dark opacity-50" />

							<div className="summary-row total">
								<span>Total Paid</span>
								<span>₹{total}</span>
							</div>

							<p className="paid-with">Paid via ****{paymentId?.slice(-4)}</p>

							<button
								className="btn-download"
								onClick={() => {
									window.open(`http://localhost:5000/api/payment/invoice/${id}`, '_blank');
								}}
							>
								Download Invoice
							</button>
						</div>
					</div>
				</div>
			</div>
		</main>
	);
};

export default PaymentSuccessPage;
